import { OnboardingCompanyProfile } from '__generated__/GQL';

export enum CompanyComplianceModuleStatus {
  /**
   * The company compliance questions haven't been filled
   */
  ToDo = 'TO_DO',
  /**
   * The company compliance questions have been filled and the company is ineligible
   */
  Refused = 'REFUSED',
  /**
   * The company compliance questions have been filled and the company is eligible
   */
  Complete = 'COMPLETE',
  /**
   * The company compliance questions should not be asked
   */
  Unnecessary = 'UNNECESSARY',
}

const getCompanyComplianceModuleStatus = ({
  companyProfile,
  shouldAskSanctionsDeclarationQuestions,
}: {
  companyProfile: Pick<
    OnboardingCompanyProfile,
    'isEligibleToOnboard' | 'isComplianceFilled'
  >;
  shouldAskSanctionsDeclarationQuestions: boolean;
}): CompanyComplianceModuleStatus => {
  const { isComplianceFilled, isEligibleToOnboard } = companyProfile;

  if (shouldAskSanctionsDeclarationQuestions === false) {
    return CompanyComplianceModuleStatus.Unnecessary;
  }

  if (isEligibleToOnboard === false) {
    return CompanyComplianceModuleStatus.Refused;
  }

  if (isComplianceFilled === false) {
    return CompanyComplianceModuleStatus.ToDo;
  }

  return CompanyComplianceModuleStatus.Complete;
};

export default getCompanyComplianceModuleStatus;
